// IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): заливка ячеек условного оформления с учётом соседей.
// Слово Игоря: «"Фон ячеек с учётом соседей" — делай все как опции, чтобы можно было переключить и выбрать». Эскиз — scratchpad cellfill-round/cellfill.html.
// Режимы (настройка fe.ux.cellFillRound, личная — feSettings / localStorage; хеш пробы &fe.ux.cellFillRound=runs):
//   off    — как было (прямоугольная заливка, ничего не рисуется);
//   runs   — K «Runs»: соседние по горизонтали ячейки одного цвета — одна капсула, скругление только у начала и конца пробега, между разными цветами зазор 2 px;
//   areas  — L «Areas»: 2D-области одного цвета — выпуклые внешние углы и вогнутые галтели (галтель рисует незалитая ячейка у внутреннего угла области);
//   tiles  — M «Tiles»: каждая ячейка — плитка с отступом 2 px и радиусом 4 px, мостики к соседям того же цвета;
//   ribbon — N «Ribbon»: непрерывная лента по залитым соседям строки, смена правила оформления — переход оттенков 12 px (соседи сливаются по правилу, не по цвету).
// Как рисуется (AttrGrid.cfr_paint): заливка остаётся собственным background-color ячейки (класс / inline правила — цвет, тёмная тема, схема — те же);
// поверх неё слоями background-image (без DOM-узлов) кладутся «маски» цвета пустой ячейки (base) в углах и зазорах, линия сетки (line) и, где нужно,
// мостики / переходы цвета. Здесь — только чистые функции: соседи → форма (cellFill_shape) → слои (cellFill_layers). Юнит — tests/unit/cellFillRound.test.mjs
export const CELL_FILL_FLAG = 'fe.ux.cellFillRound'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
export const CELL_FILL_MODES = ['off', 'runs', 'areas', 'tiles', 'ribbon']   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
// подписи пунктов меню (английский ключ t(); uk / ru — src/i18n/messages)
export const CELL_FILL_TITLES = { off: 'Plain (as before)', runs: 'Runs', areas: 'Areas', tiles: 'Tiles', ribbon: 'Ribbon' }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
export const CELL_FILL_R = { runs: 5, areas: 5, tiles: 4, ribbon: 6 }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): радиус, px
export const CELL_FILL_TILE_PAD = 2   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): отступ плитки, px
export const CELL_FILL_BLEND = 12   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): ширина перехода ленты, px

// IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): вокруг сигнальной метки ячейки (круг / пирог cell-ring,
// столбики cell-bars) — «дырка» цвета пустой ячейки в цветной заливке: круг — диск радиусом метки + 2,5 px с мягким краем 1 px, столбики — скруглённый
// прямоугольник +2,5 px. Во всех режимах fe.ux.cellFillRound, включая off; без цветного фона не рисуется. Выключатель fe.ux.signalHalo (дефолт ВКЛ)
export const CELL_HALO_FLAG = 'fe.ux.signalHalo'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
export const CELL_HALO_PAD = 2.5   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): зазор метки, px
export const cellFill_haloOn = (setting) => { try { return typeof setting === 'function' ? setting(CELL_HALO_FLAG, true) !== false : true } catch (e) { return true } }   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)

// геометрия метки в ячейке W × H по той же разметке, что рисует AttrGrid.cellView_apply / cellBars_put (CSS .cell-ring / .cell-bars):
// круг — центр по горизонтали 4 + dMax / 2 (узкая колонка, only — середина ячейки), по вертикали — середина области без нижней рамки; столбики — слот
// шириной slot от left 4 px (only — по центру), высотой h, по вертикали по центру. mark = { kind: 'c', d, dMax, only } | { kind: 'b', slot, h, only } → геометрия или null
export function cellFill_markGeom(mark, W, H) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
    if (!mark || !(W > 0) || !(H > 1)) return null
    const cy = (H - 1) / 2
    if (mark.kind === 'c' && mark.d > 0) return { kind: 'c', cx: Math.round((mark.only ? W / 2 : 4 + (mark.dMax || mark.d) / 2) * 2) / 2, cy, r: mark.d / 2 }
    if (mark.kind === 'b' && mark.slot > 0 && mark.h > 0) return { kind: 'b', x: Math.round(mark.only ? W / 2 - mark.slot / 2 : 4), y: Math.round(cy - mark.h / 2), w: mark.slot, h: mark.h }
    return null
}
export function cellFill_markKey(g) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
    if (!g) return ''
    return g.kind === 'c' ? `c${g.cx},${g.cy},${g.r}` : `b${g.x},${g.y},${g.w},${g.h}`
}
// слои ореола (верхние) — [img, x, y, w, h]
export function cellFill_haloLayers(g, W, H, base) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке)
    if (!g || !base) return []
    const P = CELL_HALO_PAD
    if (g.kind === 'c') {
        const R = g.r + P
        return [[`radial-gradient(circle at ${g.cx}px ${g.cy}px, ${base} ${Math.max(0, R - 1)}px, transparent ${R}px)`, 0, 0, W, H]]
    }
    const x0 = Math.max(0, Math.floor(g.x - P)), y0 = Math.max(0, Math.floor(g.y - P)), x1 = Math.min(W, Math.ceil(g.x + g.w + P)), y1 = Math.min(H, Math.ceil(g.y + g.h + P))
    const w = x1 - x0, h = y1 - y0, r = Math.max(0, Math.min(3, Math.floor(w / 2), Math.floor(h / 2)))
    if (w <= 0 || h <= 0) return []
    const q = (at) => `radial-gradient(circle at ${at}, ${base} ${Math.max(0, r - 0.75)}px, transparent ${r}px)`
    const L = [[`linear-gradient(${base}, ${base})`, x0 + r, y0, w - 2 * r, h], [`linear-gradient(${base}, ${base})`, x0, y0 + r, w, h - 2 * r]]
    if (r >= 1) L.push([q('100% 100%'), x0, y0, r, r], [q('0 100%'), x1 - r, y0, r, r], [q('0 0'), x1 - r, y1 - r, r, r], [q('100% 0'), x0, y1 - r, r, r])
    return L
}

// режим из настройки: дефолт — 'runs' (заказ Игоря 04.11); false / 'false' — 'off' (выключатель флага); неизвестное / ошибка — дефолт
export const CELL_FILL_DEFAULT = 'runs'   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: заливка клітинок — по умолчанию «Пробіги»)
export function cellFill_mode(setting) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    try {
        const m = typeof setting === 'function' ? setting(CELL_FILL_FLAG, CELL_FILL_DEFAULT) : setting   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: заливка клітинок — по умолчанию «Пробіги»)
        if (m === false || m === 'false') return 'off'   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: заливка клітинок — по умолчанию «Пробіги»)
        return CELL_FILL_MODES.includes(m) ? m : CELL_FILL_DEFAULT   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: заливка клітинок — по умолчанию «Пробіги»)
    } catch (e) { return CELL_FILL_DEFAULT }   // IE 2026 11 04 / ODOO-350449 (заказ Игоря: заливка клітинок — по умолчанию «Пробіги»)
}

// 'rgb(1, 2, 3)' / 'rgba(1, 2, 3, .5)' / '#abc' / '#aabbcc' → { r, g, b, a } или null
export function cellFill_rgb(c) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    const s = String(c || '').trim()
    let m = /^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)(?:[\s,/]+([\d.]+%?))?\s*\)$/i.exec(s)
    if (m) {
        let a = m[4] == null ? 1 : (m[4].endsWith('%') ? parseFloat(m[4]) / 100 : parseFloat(m[4]))
        return { r: +m[1], g: +m[2], b: +m[3], a }
    }
    m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(s)
    if (m) {
        const h = m[1].length === 3 ? m[1].split('').map(x => x + x).join('') : m[1]
        return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16), a: 1 }
    }
    return null
}

// смесь двух цветов (t — доля второго) → 'rgb(…)' / 'rgba(…)'; не разобрать — первый как есть
export function cellFill_mix(a, b, t = 0.5) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    const A = cellFill_rgb(a), B = cellFill_rgb(b)
    if (!A || !B) return a
    const f = (x, y) => Math.round(x + (y - x) * t)
    const al = Math.round((A.a + (B.a - A.a) * t) * 1000) / 1000
    return al >= 1 ? `rgb(${f(A.r, B.r)}, ${f(A.g, B.g)}, ${f(A.b, B.b)})` : `rgba(${f(A.r, B.r)}, ${f(A.g, B.g)}, ${f(A.b, B.b)}, ${al})`
}

// есть ли заливка: цвет непрозрачен (α ≥ 0,01) и отличается от фона пустой ячейки base
export function cellFill_isFill(color, base) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    const c = cellFill_rgb(color)
    if (!c || c.a < 0.01) return false
    const b = cellFill_rgb(base)
    return !(b && b.r === c.r && b.g === c.g && b.b === c.b && Math.abs(b.a - c.a) < 0.01)
}

// Сосед / сама ячейка — null (граница: нет ячейки, скрытая колонка, заморозка, строка-раздел, другой уровень дерева) или
// { k: ключ правила оформления ('' — правил нет), c: цвет заливки — строка; null — заливки нет; undefined — цвет ещё не измерен }
const known = (n) => !!n && n.c !== undefined   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
export function cellFill_filled(n) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N): залит ли (неизмеренный — по наличию правила)
    if (!n) return false
    return n.c === undefined ? !!n.k : !!n.c
}
// одного ли цвета две залитые ячейки: оба цвета измерены — по цвету, иначе — по ключу правила
export function cellFill_same(a, b) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    if (!cellFill_filled(a) || !cellFill_filled(b)) return false
    return known(a) && known(b) ? a.c === b.c : a.k === b.k
}

// форма ячейки: mode, nb = { self, l, r, t, b, tl, tr, bl, br } → описание (флаги и цвета) или null (рисовать нечего).
// unknown — форма неполная: цвет соседа ещё не измерен (AttrGrid перерисует после измерения)
export function cellFill_shape(mode, nb) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    const s = nb && nb.self
    if (!s || mode === 'off' || !CELL_FILL_MODES.includes(mode)) return null
    const sf = cellFill_filled(s) && typeof s.c === 'string'
    const eq = (n) => cellFill_same(s, n)
    if (mode === 'runs') {
        if (!sf) return null
        return { m: 'runs', l: eq(nb.l), r: eq(nb.r) }
    }
    if (mode === 'tiles') {
        if (!sf) return null
        return { m: 'tiles', c: s.c, l: eq(nb.l), r: eq(nb.r), t: eq(nb.t), b: eq(nb.b) }
    }
    if (mode === 'ribbon') {
        if (!sf) return null
        const side = (n) => {
            if (!cellFill_filled(n)) return [false, '', false]
            if (n.k === s.k) return [true, '', false]
            return typeof n.c === 'string' ? [true, cellFill_mix(n.c, s.c), false] : [true, '', true]
        }
        const [lOn, lb, lu] = side(nb.l), [rOn, rb, ru] = side(nb.r)
        const out = { m: 'ribbon', c: s.c, l: lOn, r: rOn, lb, rb }
        if (lu || ru) out.unknown = true
        return out
    }
    // areas
    if (sf) {
        const sd = {}, gp = {}
        for (const k of ['l', 'r', 't', 'b']) { sd[k] = eq(nb[k]); gp[k] = !sd[k] && cellFill_filled(nb[k]) }
        return { m: 'areas', f: 1, s: sd, g: gp }
    }
    // незалитая ячейка: вогнутая галтель в углу, где оба соседа по сторонам и сосед по диагонали — одна область
    const fil = {}
    let any = false, unknown = false
    for (const [corner, a, b, d] of [['tl', 'l', 't', 'tl'], ['tr', 'r', 't', 'tr'], ['br', 'r', 'b', 'br'], ['bl', 'l', 'b', 'bl']]) {
        const A = nb[a], B = nb[b], D = nb[d]
        if (cellFill_same(A, B) && cellFill_same(B, D)) {
            if (typeof A.c === 'string') { fil[corner] = A.c; any = true } else unknown = true
        }
    }
    if (!any) return unknown ? { m: 'areas', f: 0, fil: {}, unknown: true, empty: true } : null
    const out = { m: 'areas', f: 0, fil }
    if (unknown) out.unknown = true
    return out
}

// ключ кеша формы (без флага unknown) — строка
export function cellFill_shapeKey(sh) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    if (!sh) return ''
    const b = (v) => (v ? 1 : 0)
    if (sh.m === 'plain') return 'P'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): только ореол (режим off / незалитая форма)
    if (sh.m === 'runs') return `K${b(sh.l)}${b(sh.r)}`
    if (sh.m === 'tiles') return `M${b(sh.l)}${b(sh.r)}${b(sh.t)}${b(sh.b)}|${sh.c}`
    if (sh.m === 'ribbon') return `N${b(sh.l)}${b(sh.r)}|${sh.c}|${sh.lb}|${sh.rb}`
    if (sh.f) return `L1${b(sh.s.l)}${b(sh.s.r)}${b(sh.s.t)}${b(sh.s.b)}${b(sh.g.l)}${b(sh.g.r)}${b(sh.g.t)}${b(sh.g.b)}`
    return `L0|${sh.fil.tl || ''}|${sh.fil.tr || ''}|${sh.fil.br || ''}|${sh.fil.bl || ''}`
}

const solid = (c) => `linear-gradient(${c}, ${c})`   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
// маски цвета base вне скруглённого прямоугольника [x0, x1) × [y0, y1) ячейки W × H: полосы по краям + четверти у скруглённых углов cr
function masks(L, base, W, H, x0, y0, x1, y1, cr, r0) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    if (y0 > 0) L.push([solid(base), 0, 0, W, y0])
    if (y1 < H) L.push([solid(base), 0, y1, W, H - y1])
    if (x0 > 0) L.push([solid(base), 0, y0, x0, y1 - y0])
    if (x1 < W) L.push([solid(base), x1, y0, W - x1, y1 - y0])
    const r = Math.floor(Math.max(0, Math.min(r0, (y1 - y0) / 2, (x1 - x0) / 2)))
    if (r < 1) return
    const q = (at) => `radial-gradient(circle at ${at}, transparent ${Math.max(0, r - 0.75)}px, ${base} ${r}px)`
    if (cr.tl) L.push([q('100% 100%'), x0, y0, r, r])
    if (cr.tr) L.push([q('0 100%'), x1 - r, y0, r, r])
    if (cr.br) L.push([q('0 0'), x1 - r, y1 - r, r, r])
    if (cr.bl) L.push([q('100% 0'), x0, y1 - r, r, r])
}

// слои фона: форма sh, ячейка W × H px (вся рамка ячейки, border-box), base — фон пустой ячейки, line — цвет линии сетки →
// { img, size, pos } — значения background-image / -size / -position (слои через запятую, первый — верхний), или null
export function cellFill_layers(sh, W, H, base, line, mark) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    W = Math.round(W); H = Math.round(H)
    if (!sh || !(W > 2) || !(H > 2) || !base) return null
    const top = [], mid = [], low = []   // top — мостики / переходы, mid — линия сетки, low — маски
    const ln = line || base
    const lineB = () => mid.push([solid(ln), 0, H - 1, W, 1])
    const halo = cellFill_haloLayers(mark, W, H, base)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): верхний слой — ореол метки
    if (sh.m === 'plain') {
        if (!halo.length) return null
    } else if (sh.m === 'runs') {
        masks(low, base, W, H, sh.l ? 0 : 1, 1, sh.r ? W : W - 1, H - 1, { tl: !sh.l, bl: !sh.l, tr: !sh.r, br: !sh.r }, CELL_FILL_R.runs)
        lineB()
    } else if (sh.m === 'ribbon') {
        const B = Math.min(CELL_FILL_BLEND, Math.floor(W / 2))
        if (sh.lb) top.push([`linear-gradient(to right, ${sh.lb}, ${sh.c})`, 0, 1, B, H - 2])
        if (sh.rb) top.push([`linear-gradient(to right, ${sh.c}, ${sh.rb})`, W - B, 1, B, H - 2])
        masks(low, base, W, H, sh.l ? 0 : 1, 1, sh.r ? W : W - 1, H - 1, { tl: !sh.l, bl: !sh.l, tr: !sh.r, br: !sh.r }, CELL_FILL_R.ribbon)
        lineB()
    } else if (sh.m === 'tiles') {
        const p = CELL_FILL_TILE_PAD, R = CELL_FILL_R.tiles
        masks(low, base, W, H, p, p, W - p, H - p, { tl: 1, tr: 1, br: 1, bl: 1 }, R)
        const vh = H - 2 * p - 2 * R, hw = W - 2 * p - 2 * R
        if (sh.r && vh > 0) top.push([solid(sh.c), W - p, p + R, p, vh])
        if (sh.l && vh > 0) top.push([solid(sh.c), 0, p + R, p, vh])
        if (sh.b && hw > 0) top.push([solid(sh.c), p + R, H - p, hw, p])
        if (sh.t && hw > 0) top.push([solid(sh.c), p + R, 0, hw, p])
        lineB()
    } else if (sh.m === 'areas' && sh.f) {
        const g = sh.g, s = sh.s
        masks(low, base, W, H, g.l ? 1 : 0, g.t ? 1 : 0, W - (g.r ? 1 : 0), H - (g.b ? 1 : 0),
            { tl: !s.t && !s.l, tr: !s.t && !s.r, br: !s.b && !s.r, bl: !s.b && !s.l }, CELL_FILL_R.areas)
        if (!s.b) lineB()
    } else if (sh.m === 'areas') {
        const r = Math.floor(Math.max(0, Math.min(CELL_FILL_R.areas, H / 2, W / 2)))
        const f = (c, at) => `radial-gradient(circle at ${at}, transparent ${Math.max(0, r - 0.75)}px, ${c} ${r}px)`
        if (r >= 1) {
            if (sh.fil.tl) top.push([f(sh.fil.tl, '100% 100%'), 0, 0, r, r])
            if (sh.fil.tr) top.push([f(sh.fil.tr, '0 100%'), W - r, 0, r, r])
            if (sh.fil.br) top.push([f(sh.fil.br, '0 0'), W - r, H - r, r, r])
            if (sh.fil.bl) top.push([f(sh.fil.bl, '100% 0'), 0, H - r, r, r])
        }
    } else return null
    const L = halo.concat(top, mid, low).filter(x => x[3] > 0 && x[4] > 0)
    if (!L.length) return null
    return { img: L.map(x => x[0]).join(', '), size: L.map(x => `${x[3]}px ${x[4]}px`).join(', '), pos: L.map(x => `${x[1]}px ${x[2]}px`).join(', ') }
}

// кеш слоёв по ключу (форма, W, H, base, line); переполнение — сброс целиком
const _layerCache = new Map()   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
export function cellFill_layersCached(sh, W, H, base, line, stats, mark) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    if (!sh) return null
    const key = `${cellFill_shapeKey(sh)}|${Math.round(W)}|${Math.round(H)}|${base}|${line}|${cellFill_markKey(mark)}`   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: ореол вокруг сигнальных меток в цветной ячейке): + метка
    let v = _layerCache.get(key)
    if (v !== undefined) { if (stats) stats.hit = (stats.hit || 0) + 1; return v }
    if (_layerCache.size > 4000) _layerCache.clear()
    v = cellFill_layers(sh, W, H, base, line, mark)
    _layerCache.set(key, v)
    if (stats) stats.miss = (stats.miss || 0) + 1
    return v
}

// индекс видимого соседа строки r в строках wijmo rows (шаг dir = −1 вверх / +1 вниз): скрытые строки (свёрнутая группа) пропускаются;
// сосед другого уровня дерева — −1 (граница); пропуск ограничен maxSkip строк
export function cellFill_rowNeighbor(rows, r, dir, maxSkip = 200) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: фон ячеек с учётом соседей — опции K/L/M/N)
    if (!rows) return -1
    const n = rows.length | 0, self = rows[r]
    let i = r + dir, k = 0
    while (i >= 0 && i < n && k < maxSkip) {
        const x = rows[i]
        if (x && x.isVisible !== false) {
            if (self && typeof self.level === 'number' && typeof x.level === 'number' && x.level !== self.level) return -1
            return i
        }
        i += dir; k++
    }
    return -1
}

// IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки): индекс видимого соседа колонки c в колонках wijmo cols
// (шаг dir = −1 влево / +1 вправо): скрытые (isVisible / visible = false) и нулевой ширины колонки пропускаются — между месяцами стоят скрытые колонки .offset,
// и пробег не должен рваться на каждом месяце. Граница — −1: край, переход через границу заморозки frozen (число замороженных колонок), разрыв колонок
// (isBreak(col) — зазор перед колонкой: слева у самой ячейки, справа — у найденного соседа). Пропуск ограничен maxSkip колонок
export function cellFill_colNeighbor(cols, c, dir, frozen = 0, isBreak = null, maxSkip = 200) {   // IE 2026 11 03 / ODOO-350449 (проба p252: фон ячеек — слои поверх cell-lt/cell-rc, соседи через скрытые колонки)
    if (!cols || !(dir === 1 || dir === -1)) return -1
    const n = cols.length | 0, fr = frozen | 0
    const brk = (i) => { try { return !!(isBreak && isBreak(cols[i], i)) } catch (e) { return false } }
    if (dir < 0 && brk(c)) return -1
    let i = c + dir, k = 0
    while (i >= 0 && i < n && k < maxSkip) {
        if (fr > 0 && (i < fr) !== (c < fr)) return -1   // граница заморозки рвёт пробег
        const x = cols[i]
        const w = x ? (typeof x.renderWidth === 'number' ? x.renderWidth : (typeof x.width === 'number' ? x.width : 1)) : 0
        if (x && x.isVisible !== false && x.visible !== false && w > 0) return dir > 0 && brk(i) ? -1 : i
        i += dir; k++
    }
    return -1
}

// IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4): заливки, которых нет в ключах правил оформления, — тепловая hslGroup (колонка / строка
// AttrTabGrid, цвет по значению, inline с !important) и цвет уровня группы use_hslGroup (inline). Их цвет известен по данным, без замера:
// у соседа — тот же расчёт, что у formatItem. Ключ 'heat:<rgb>' — у каждого оттенка свой (ribbon смешивает соседние оттенки, runs / areas / tiles
// сливают только одинаковые цвета). Расчёт оттенка вынесен из AttrGrid.formatItem_cells (тот же код, теперь общий с соседями слоя)
// оттенок тепловой заливки: grp — шкала группы (min / max / p5 / p95 своего уровня), v — значение. undefined — шкалы нет или значение не число
// (ячейка не тепловая), null — значение без оттенка, иначе 'hsl(…)' (строка как прежде ставилась в стиль ячейки)
export function cellFill_heatHsl(grp, v) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
    const min = (grp && grp.min) || 0
    const max = (grp && grp.max) || 0
    if (!(typeof v === 'number' && !isNaN(v) && max > min)) return undefined
    // границы для отрисовки: p5–p95 (если есть), иначе min–max
    let pLow = (grp.p5 ?? min)
    let pHigh = (grp.p95 ?? max)
    const eps = 1e-9
    // ДИВЕРГЕНТНО: разные цвета для отрицательных/положительных вокруг 0
    let bg = null
    if (-10 < pLow && pHigh < 10) {
        if (v < 0) {
            const pLowNeg = -Math.min(max, 0)
            const pHighNeg = -min
            const vClipped = Math.min(pHighNeg, Math.max(pLowNeg, -v))
            const a = (vClipped - pLowNeg) / (pHighNeg - pLowNeg)
            const hueMin = 0, hueMax = 30
            bg = `hsl(${hueMax + (hueMin - hueMax) * a}, 100%, 85%)`
        } else if (v > 0) {
            pLow = Math.max(min, 0)
            pHigh = max
            const vClipped = Math.min(pHigh, Math.max(pLow, v))
            const a = (vClipped - pLow) / (pHigh - pLow)
            const hueMin = 60, hueMax = 240   // жёлто-зелёный … бирюзовый
            bg = `hsl(${hueMax + (hueMin - hueMax) * a}, 100%, 95%)`
        }
    } else {
        if (v < 0) {
            const pLowNeg = -Math.min(max, 0)
            const pHighNeg = -min
            const vClipped = Math.min(pHighNeg, Math.max(pLowNeg, -v))
            let a = (vClipped - pLowNeg) / Math.max(eps, (pHighNeg - pLowNeg))
            a = Math.log10(1 + 9 * a)
            const hueMin = 0, hueMax = 30
            bg = `hsl(${hueMax + (hueMin - hueMax) * a}, 100%, 85%)`
        } else if (v > 0) {
            pLow = Math.max(pLow, 0)
            const vClipped = Math.min(pHigh, Math.max(pLow, v))
            let a = (vClipped - pLow) / Math.max(eps, (pHigh - pLow))
            a = Math.log10(1 + 9 * a)
            const hueMin = 60, hueMax = 240
            bg = `hsl(${hueMax + (hueMin - hueMax) * a}, 100%, 95%)`
        }
    }
    return bg
}
// цвет строки-группы уровня level при use_hslGroup (как formatItem_cells)
export function cellFill_groupHsl(level) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
    if (!(level >= 0)) return null
    return `hsl(${(level * 47) % 360}, ${30 + (level * 13) % 50}%, ${85 - (level * 7) % 30}%)`
}
// 'hsl(h, s%, l%)' → 'rgb(r, g, b)' (каналы — к ближайшему целому); не разобрать — null. Сравниваются между собой (одинаковый оттенок — один пробег),
// смешиваются (cellFill_mix) и проверяются на заливку (cellFill_isFill) — те понимают только rgb / hex
export function cellFill_hslRgb(s) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
    const m = /^hsla?\(\s*(-?[\d.]+)(?:deg)?[\s,]+([\d.]+)%[\s,]+([\d.]+)%\s*\)$/i.exec(String(s || '').trim())
    if (!m) return null
    const h = (((+m[1]) % 360) + 360) % 360 / 360, sa = Math.min(1, +m[2] / 100), l = Math.min(1, +m[3] / 100)
    const q = l < 0.5 ? l * (1 + sa) : l + sa - l * sa, p = 2 * l - q
    const ch = (t) => {
        if (t < 0) t += 1
        if (t > 1) t -= 1
        const v = t < 1 / 6 ? p + (q - p) * 6 * t : t < 1 / 2 ? q : t < 2 / 3 ? p + (q - p) * (2 / 3 - t) * 6 : p
        return Math.round(v * 255 + 1e-7)   // 229,4999… от двоичной погрешности — к ближайшему по точному значению (229,5 → 230)
    }
    return `rgb(${ch(h + 1 / 3)}, ${ch(h)}, ${ch(h - 1 / 3)})`
}
// признак ячейки с заливкой по данным (тепловая / уровень группы): { k, c } слоя — цвет известен, замера нет; оттенок не разобран — null
export function cellFill_dataFill(hsl, kind = 'heat') {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
    const c = cellFill_hslRgb(hsl)
    return c ? { k: `${kind}:${c}`, c } : null
}
// ключ ячейки по ключам правил: колонка данных — ключи как есть; колонка НЕ данных (атрибут строки отчёта — doc.minDOS, заголовок строки)
// со своими правилами — ключ с привязкой колонки: цвет ключа там замеряется отдельно (CSS колонки может давать свой фон под тем же классом);
// без правил — '' (заливки нет) в любой колонке
export function cellFill_cellKey(keys, isData, binding) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р4)
    const k = (keys || []).join('|')
    return !k || isData ? k : `${k}§col:${binding || ''}`
}
